import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import ModalEditRow from './ModalEditRow';

export default compose(
  withCitiesAndStreets
)(ModalEditRow);